module.exports = __webpack_public_path__ + "assets/ea1a36ec35462054ba510cc9d6044332.png";